import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { FilterItem } from '@pos/interfaces/pos-session';
import { AccountingReportBundledPayment } from '@accounting/interfaces/accounting-reports';
import Table from '@shared/components/tables/table.vue';
@Component({
  name: 'bc-sale-session-bundled-payments-table',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bc-table': Table,
  },
})
export default class SaleSessionBundledPaymentsTable extends mixins(AbstractField) {
  @Prop({ type: Boolean, default: true }) readonly fetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: true }) readonly hideCheckColumn: boolean;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly externalBundledPayments: AccountingReportBundledPayment[];

  localLoading: boolean = false;
  bundledPaymentsObservableSubscription = null;
  bundledPayments: AccountingReportBundledPayment[] = [];
  fields = [
    {
      key: 'method',
      headerLabel: this.$t('global.grouped_payments.method'),
      order: 0,
      thClass: 'w-50',
    },
    {
      key: 'paid',
      headerLabel: this.$t('global.grouped_payments.paid'),
      order: 1,
      thClass: 'w-50',
    },
  ];

  get loadingPayments() {
    return this.loading || this.localLoading;
  }

  set loadingPayments(value) {
    this.localLoading = value;
    this.$emit('on-loading-change', value);
  }

  get posSessionId(): number {
    const filters = (this.$attrs?.filters || []) as FilterItem[];
    const filter = filters.find(item => {
      return item?.filterField === 'pos_session_id';
    });
    return filter?.value;
  }

  public mounted() {
    if (this.fetchData) {
      this.getBundledPayments();
    }
  }

  get processedBundledPayments(): AccountingReportBundledPayment[] {
    let itemsToProcess = [];
    if (this.externalBundledPayments.length) {
      itemsToProcess = this.externalBundledPayments;
    }
    if (this.bundledPayments.length) {
      itemsToProcess = this.bundledPayments;
    }
    return this.processBundledPayments(itemsToProcess);
  }

  processBundledPayments(bundledPayments: AccountingReportBundledPayment[]) {
    const items = [];
    let total_paid = 0;
    let total_cancelled = 0;
    let total_ongoing = 0;
    Object.entries(bundledPayments).forEach(item => {
      items.push({
        method: this.$t('global.payment.' + item[1].method).toString(),
        paid: this.formatAmount(item[1].totalPaid),
        cancelled: this.formatAmount(item[1].totalCancelled),
        ongoing: this.formatAmount(item[1].totalOngoing),
      });
      total_paid += item[1].totalPaid;
      total_cancelled += item[1].totalCancelled;
      total_ongoing += item[1].totalOngoing;
    });
    items.push({
      method: this.$t('global.total'),
      paid: this.formatAmount(total_paid),
      cancelled: this.formatAmount(total_cancelled),
      ongoing: this.formatAmount(total_ongoing),
      _rowVariant: 'light',
    });
    return items;
  }

  public getBundledPayments() {
    this.loadingPayments = true;
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('pos-sessions')}/${
      this.posSessionId
    }/grouped-payments`;

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(fetchEntityPath);

    if (this.bundledPaymentsObservableSubscription) {
      this.bundledPaymentsObservableSubscription.unsubscribe();
    }

    this.bundledPaymentsObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.bundledPayments = res.data;
        this.loadingPayments = false;
      },
      error => {
        console.log(error);
      },
    );
  }

  formatAmount(value: number) {
    return this.$bpcHelper.formatPrice(value);
  }
}
